import React, { useEffect, useRef, useState } from 'react';
import useClickOutside from '../../hooks/useClickOutside';
import { t } from '../../i18n/i18n';
import { Window } from '../../utils/window';
import Checkbox from '../Checkbox/Checkbox';
import './ConfirmModal.scss';
import DebouncedButton from '../Button/Button';

const lsKey = 'favorite-delete-not-ask';

const ConfirmModal = ({
  show,
  setShow,
  callback,
  text,
  title,
  cautionText,
  confirmButtonText,
  cancelButtonText,
  withoutDontAsk = false,
}) => {
  const [notAskAgain, setNotAskAgain] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const modalRef = useRef(null);
  useClickOutside(modalRef, () => setShow(false));

  useEffect(() => {
    if (show) {
      const notAsk = Window().localStorage.getItem(lsKey);
      if (notAsk) {
        setShow(false);
        callback();
      } else {
        setShowModal(true);
      }
    } else {
      setShowModal(false);
    }
  }, [show]);

  const handleNotAskAgain = () => {
    if (notAskAgain) {
      localStorage.setItem('favorite-delete-not-ask', 'true');
    }
  };

  const handleConfirm = () => {
    callback();
    setShow(false);
    handleNotAskAgain();
  };

  const handleCancel = () => {
    setShow(false);
  };

  return (
    <div
      ref={modalRef}
      className={`bg-white position-absolute confirm-modal-container right-0 mr-2 z-index-2 ${
        showModal ? 'show-confirm-modal' : 'not-show-confirm-modal'
      }`}
    >
      <div className={showModal ? 'd-flex flex-column p-3' : 'd-none'}>
        {title && (
          <div className="mt-2">
            <strong>{title}</strong>
          </div>
        )}
        <span className="">{text}</span>
        {cautionText && <div className="mt-2 text-danger small">{cautionText}</div>}
        {withoutDontAsk || (
          <div className="d-flex align-items-center mt-3">
            <span className=" text-xs mr-1">{t('CONFIRM_MODAL_DO_NOT_ASK_AGAIN')}</span>
            <Checkbox
              onClick={() => {
                setNotAskAgain((state) => !state);
              }}
            />
          </div>
        )}
        <div className="mt-3 d-flex justify-content-end">
          <button type="button" className="button-cancel-modal px-3 mr-2" onClick={handleCancel}>
            <span className="button-cancel-modal-text  font-weight-bold">{cancelButtonText}</span>
          </button>
          <DebouncedButton
            type="button"
            className="button-confirm-modal px-3"
            onClick={handleConfirm}
          >
            <span className="button-confirm-modal-text  font-weight-bold">{confirmButtonText}</span>
          </DebouncedButton>
        </div>
      </div>
    </div>
  );
};
export default ConfirmModal;
